import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Card, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { Navigate } from 'react-router-dom';

function Register() {
    const { register, handleSubmit, formState: { errors }, getValues } = useForm();
    const [error, setError] = useState('');
    const [isRegistered, setIsRegistered] = useState(false);

    function submit(e) {
        let bodyFormData = new FormData();
        bodyFormData.append("studentNumber", e.studentNumber);
        bodyFormData.append("firstName", e.firstName);
        bodyFormData.append("lastName", e.lastName);
        bodyFormData.append("year", e.year);
        bodyFormData.append("studyMode", e.studyMode === "true");
        bodyFormData.append("password", e.password);

        axios.post("/auth/register", bodyFormData,{headers: {'content-type': 'application/x-www-form-urlencoded'}})
            .then(response => {
                if(response.status === 201) {
                    setIsRegistered(true);
                }else{
                    if(response.response && response.response.data && response.response.data.message){
                        setError(response.response.data.message);
                    }else{
                        setError("An unexpected error occurred.");
                    }
                }
            })
            .catch(err => {
                // Handle error responses from server here
                if(err.response && err.response.data && err.response.data.message){
                    setError(err.response.data.message);
                }else{
                    setError("An unexpected error occurred.");
                }
            });
    }

    if (isRegistered) {
        return <Navigate to="/login" />;
    }

    return (
        <>
            <Card.Title>Sign-up</Card.Title>
            <Form onSubmit={handleSubmit(submit)}>
                <label style={{color: "red"}}>{error}</label>
                <Form.Group className="mb-3" controlId="formStudentNumber">
                    <Form.Label>Student Number</Form.Label>
                    <Form.Control {...register("studentNumber", { required: true })} type="text" placeholder="Enter Student Number" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formFirstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control {...register("firstName", { required: true })} type="text" placeholder="Enter First Name" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formLastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control {...register("lastName", { required: true })} type="text" placeholder="Enter Last Name" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formYear">
                    <Form.Label>Year</Form.Label>
                    <Form.Control {...register("year", { required: true })} type="number" placeholder="Enter Year" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formStudyMode">
                    <Form.Label>Study Mode</Form.Label>
                    <Form.Select {...register("studyMode", { required: true })}>
                        <option value="true">Full-time</option>
                        <option value="false">Part-time</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control {...register("password", { required: "Password is required!" })} type="password" placeholder="Password" />
                    {errors.password && <p style={{ color: 'red' }}>{errors.password.message}</p>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPasswordRepeat">
                    <Form.Label>Repeat Password</Form.Label>
                    <Form.Control {...register("passwordRepeat", {
                        required: "Please confirm password!",
                        validate: value => value === getValues().password || "The passwords do not match"
                    })}
                                  type="password" placeholder="Repeat Password"
                    />
                    {errors.passwordRepeat && <p style={{ color: 'red' }}>{errors.passwordRepeat.message}</p>}
                </Form.Group>
                <Button variant="primary" style={{width: '100%'}} type="submit">
                    Register
                </Button>
            </Form>
        </>
    );
}

export default Register;
